'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMapsButtonControl = function GoogleMapsButtonControl(element, args) {
  _classCallCheck(this, GoogleMapsButtonControl);

  var onclick = function onclick() {
    if (!args.getValues) {
      return;
    }

    var values = args.getValues();
    var data = values.filter(function (value) {
      return value && value.trim && value.trim() !== '';
    });

    if (args.getValues().length === 0) {
      return;
    }

    var locationString = data.join(', ');

    if (locationString) {
      open('//maps.google.com/?q=' + encodeURIComponent(locationString));
    } else {
      alert('Vul een geldig adres in.');
    }
  };

  var button = document.createElement('button');
  button.className = 'icon';
  button.innerHTML = '\uE0A6';
  button.onclick = onclick;
  var fragment = document.createDocumentFragment();
  fragment.appendChild(button);

  element.appendChild(fragment);
};

exports.default = GoogleMapsButtonControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/GoogleMapsButtonControl.js
// module id = 49
// module chunks = 0